// extracted by mini-css-extract-plugin
export default {"diet_container":"Diet-page-fc_diet_container__yU4Rb","diet_page_head":"Diet-page-fc_diet_page_head__Nz8Ms"};